export const WIRE_TEMPLATE_CONTAINER_TAG_NAME = 'wire-template-container';
